import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import { FaClipboardList, FaExclamationCircle } from "react-icons/fa";
import {
  postDataWithBody,
  postDataWithBodyFrGIS,
} from "../../../Services/Services";
import {
  claimIndTask,
  completeIndiTask,
  completeIndivTask,
} from "../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useKeycloak } from "@react-keycloak/web";
import "./TaskModalWithCommentSop.css";

const TaskModalWithComment = (props) => {
  const {
    title,
    titleValue,
    show,
    handleToggle,
    size,
    popupLabel,
    buttonLabel,
    data,
    getMyTaskList,
    setShowPop,
  } = props;
  const [comment, setComment] = useState(data || ""); // Track textarea value
  const [error, setError] = useState(""); // To store validation error message

  const { keycloak } = useKeycloak();

  const todayDate = new Date().toISOString().split("T")[0];

  console.log(props,"props data")

  // Function to validate the comment length
  const validateCommentLength = () => {
    if (comment.length > 250) {
      setError("Maximum 250 characters are allowed.");
      return false;
    }
    setError(""); // Clear error message when character count is valid
    return true;
  };

  // Handle comment change and validation
  const handleCommentChange = (e) => {
    setComment(e.target.value); // Update comment state
    validateCommentLength(); // Validate character length on every change
  };

  async function saveConfigData() {
    if (!validateCommentLength()) {
      return; // Prevent submission if validation fails
    }
  
    let input = {
      id: props.taskData.id,
      task_id: props.taskData.task_id,
      assignType: props.taskData.assign_type,
      assignTask: props.taskData.assign_task,
      description: comment,
      email: keycloak.idTokenParsed.email,
      taskStartDate: todayDate,
    };
  
    let input1 = {
      id: props.taskData.id,
      description: comment,
      taskCompletedDate: todayDate,
    };
  
    let res = null;
  
    if (props.taskData.task_status_code === "TASK_EXE_STATUS_NEW_TASK") {
      res = await postDataWithBody(claimIndTask, input, {});
    } else if (props.taskData.task_status_code === "TASK_EXE_STATUS_INPROGRESS") {
      res = await postDataWithBody(completeIndivTask, input1, {});
    }
  
    if (res && res.status === "success") {
      props.showSuccessMsg();
      toast.success(res.msg, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      toast.error(res?.msg || "Something went wrong", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      setShowPop(false);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  
    console.log("Input Object: ", props.taskData);
    getMyTaskList();
  }
  

  return (
    <>
      <Modal
        show={show}
        onHide={handleToggle}
        size={size}
        className="table__modal__popup task-action-modal"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <span className="task-icon-badge">
              <FaClipboardList size={14} color="#fff" />
            </span>
            {title}
            {titleValue}
          </Modal.Title>
          <span className="task-close-btn" onClick={handleToggle}>
            <XCircleblack style={{ color: "#fff" }} width="1.1em" height="1.1em" />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            {popupLabel && (
              <label className="create__resource--label" htmlFor="tfld_config_value">
                {popupLabel}
              </label>
            )}

            <span className="task-label">Description</span>
            <div className="task-desc-box">{props.taskData.description}</div>

            <span className="task-label">
              Action Taken <span style={{ color: "#e74c3c" }}>*</span>
            </span>
            <textarea
              placeholder="Write your action here"
              className="task-textarea"
              maxLength={250}
              id="modal_comment_txt_area"
              value={comment}
              onChange={handleCommentChange} // Update comment state and validate length on change
            />
            <div className="task-counter">{comment.length}/250</div>
            {error && (
              <div className="task-error">
                <FaExclamationCircle size={12} />
                {error}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={saveConfigData}
            type="button"
            className="btn-save"
            disabled={error !== "" || comment.length === 0} // Disable button if there's an error or comment is empty
          >
            {buttonLabel}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TaskModalWithComment;
